export default __webpack_public_path__ + "static/media/216property-gallery4.40213e1a.webp";